import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { Row, Col } from "react-bootstrap";

import { Formik, Form } from "formik";
import Button from "../../../../shared/components/Buttons/Button";
import { deviceActions } from "../../../../redux/actions/device.action";
import InputTextField from "../../../../shared/components/inputTextField/InputTextField";
import Topbar from "../../../../shared/components/topbar/Topbar";
import {
  buttonTypeConstants,
  buttonNameConstants,
  routesPathConstants,
  EMPTY_STRING,
} from "../../../../constants";
import { createCompanyDynamicUrl } from "../../../../shared/utility";
import { STORE_CARD_PAYMENT_TYPE_ENUMS } from "../../../../system/globalEnums";

//-------EditDevice component start here
const EditDevice = (props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  //-------Props
  const { checkDeviceStatus, updateDeviceName, currentStore } = props;

  const isSlingshotDevice =
    state?.data?.deviceType === STORE_CARD_PAYMENT_TYPE_ENUMS.SLINGSHOT;

  //-------initial state for form
  const initialValues = {
    serialNumber: state?.data?.serialNumber || EMPTY_STRING,
    deviceId: state?.data?.deviceId || EMPTY_STRING,
    poiId: state?.data?.poiId || EMPTY_STRING,
    store: state?.data?.store || EMPTY_STRING,
    deviceType: state?.data?.deviceType || EMPTY_STRING,
    id: state?.data?.id || EMPTY_STRING,
  };

  const validateEditDevice = (values) => {
    const errors = {};
    if (!values.poiId) {
      errors.poiId = "Nickname is required.";
    }
    return errors;
  };

  //-------handle submit for add new device form
  const handleSubmit = (data) => {
    if (data.deviceType === STORE_CARD_PAYMENT_TYPE_ENUMS.SLINGSHOT) {
      delete data.serialNumber;
    } else {
      delete data.deviceId;
    }

    updateDeviceName(state?.data?.id, data);
  };

  //-------handle cancel button
  const handleCancelButton = () => {
    navigate(createCompanyDynamicUrl(routesPathConstants.SETTINGS_DEVICES));
  };

  //-------check device status
  const handleCheckStatus = (identifier) => {
    if (identifier) {
      checkDeviceStatus(identifier);
    }
  };

  useEffect(() => {
    if (state.currentStore.id !== currentStore.id) {
      navigate(createCompanyDynamicUrl(routesPathConstants.SETTINGS_DEVICES));
    } // eslint-disable-next-line
  }, [currentStore]);
  return (
    <>
      <Topbar
        title={"Edit Device"}
        backNavigation={{
          isVisible: true,
          route: routesPathConstants.SETTINGS_DEVICES,
        }}
      />
      <Row className="m-0 p-0 w-100">
        <Formik
          initialValues={initialValues}
          validate={validateEditDevice}
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form className="m-0">
              <Row className="m-0">
                <Col md={6} className="mb-3">
                  {isSlingshotDevice ? (
                    <InputTextField
                      name="deviceId"
                      label="Device ID"
                      placeHolder="Enter Device ID"
                      disabled={true}
                    />
                  ) : (
                    <InputTextField
                      name="serialNumber"
                      label="Serial Number"
                      placeHolder="Enter Serial Number"
                      disabled={true}
                    />
                  )}
                </Col>
                <Col md={6} className="mb-3">
                  <InputTextField
                    name="poiId"
                    label="Nickname"
                    placeHolder="Enter Nickname"
                  />
                </Col>
                <Col md={6} className="mb-3"></Col>
                <Col
                  md={6}
                  className="d-flex justify-content-end align-items-end mb-3"
                >
                  <Button
                    type="button"
                    className={`w-50 ${
                      !(isSlingshotDevice
                        ? values.deviceId
                        : values.serialNumber) && "disable-button"
                    }`}
                    label={buttonNameConstants.CHECK_STATUS}
                    handleClick={() =>
                      handleCheckStatus(
                        isSlingshotDevice
                          ? values.deviceId
                          : values.serialNumber
                      )
                    }
                    isDisabled={
                      !(isSlingshotDevice
                        ? values.deviceId
                        : values.serialNumber)
                    }
                  ></Button>
                </Col>
                <Col md={6} className="mb-3 d-flex gap-2">
                  <Button
                    type="button"
                    label={buttonNameConstants.CANCEL}
                    handleClick={() => {
                      handleCancelButton();
                    }}
                    buttonType={buttonTypeConstants.GHOST_BUTTON}
                    className="w-100"
                  ></Button>
                  <Button
                    type="submit"
                    className="w-100"
                    label={buttonNameConstants.UPDATE}
                  ></Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Row>
    </>
  );
}; //-------EditDevice component end here

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  company: state.authentication.company,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  checkDeviceStatus: (identifier) =>
    dispatch(deviceActions.checkDeviceStatus(identifier)),
  updateDeviceName: (id, data) =>
    dispatch(deviceActions.updateDeviceName(id, data)),
});

//-------Export EditDevice Component
export default connect(mapStateToProps, mapDispatchToProps)(EditDevice);
